var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgPicwiseLogo = function SvgPicwiseLogo(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 288 145",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 540,
    x2: 284,
    y1: 223,
    y2: 342,
    gradientTransform: "translate(-277 -226)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59FFC0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41B98B",
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259 14.6c0 8.07 6.54 14.6 14.6 14.6 8.07 0 14.6-6.54 14.6-14.6 0-8.07-6.54-14.6-14.6-14.6-8.07-.001-14.6 6.54-14.6 14.6M190.7 1.3c-3.1 1.46-5.42 3.9-6.76 6.79l-26.9 53.9-25.3-53.9c-3.28-7-11.6-10-18.6-6.74-7 3.28-10 11.6-6.74 18.6l37.5 80.1a14.005 14.005 0 0 0 12.679 8.061c5.3 0 10.1-2.99 12.5-7.74l27.1-54.2 25.3 53.9c2.28 4.86 7.13 7.99 12.5 8.06l.186.001c5.29 0 10.1-2.99 12.5-7.73l24.2-48.2c3.46-6.91.67-15.3-6.24-18.8-6.91-3.46-15.3-.669-18.8 6.24l-11.2 22.4-25.3-53.9c-2.38-5.08-7.42-8.06-12.7-8.06a13.93 13.93 0 0 0-5.93 1.32m-162 52.7c0-14.4 11.7-26.1 26.1-26.1 14.4 0 26.1 11.7 26.1 26.1s-11.7 26.1-26.1 26.1c-14.4 0-26.1-11.7-26.1-26.1m26.1-54.1c-29 0-52.7 22.9-54 51.5-.038.419-.064.842-.064 1.27v78c0 7.73 6.27 14 14 14s14-6.27 14-14v-29.4c7.73 4.27 16.6 6.71 26.1 6.71 29.8 0 54.1-24.2 54.1-54.1 0-29.8-24.2-54.1-54.1-54.1z",
    fill: "url(#a)"
  })));
};

export default SvgPicwiseLogo;